import axios from 'axios';

const svgTaskMap = {};

export default src => {
    if (!src) {
        return null;
    }
    if (!svgTaskMap[src]) {
        svgTaskMap[src] = axios.get(src);
    }
    return svgTaskMap[src];
};